import React, { useEffect, useState } from 'react';

interface LiveCounterBlockProps {
  targetDate: Date;
  title?: string;
  text?: string;
  daysLabel?: string;
  hoursLabel?: string;
  minutesLabel?: string;
  secondsLabel?: string;
  className?: string;
}

const formatTime = (time: number) => (time < 10 ? `0${time}` : time.toString());

export const LiveCounterBlock = ({
  targetDate,
  title = '',
  text = '',
  daysLabel = '',
  hoursLabel = '',
  minutesLabel = '',
  secondsLabel = '',
  className = '',
}: LiveCounterBlockProps) => {
  const [timeLeft, setTimeLeft] = useState({
    days: '0',
    hours: '0',
    minutes: '0',
    seconds: '0',
  });

  useEffect(() => {
    const targetTime = targetDate.getTime();

    const updateCountdown = () => {
      const now = new Date().getTime();
      const distance = targetTime - now;

      if (distance <= 0) {
        setTimeLeft({ days: '0', hours: '0', minutes: '0', seconds: '0' });
        return;
      }

      setTimeLeft({
        days: formatTime(Math.floor(distance / (1000 * 60 * 60 * 24))),
        hours: formatTime(
          Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        ),
        minutes: formatTime(
          Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        ),
        seconds: formatTime(Math.floor((distance % (1000 * 60)) / 1000)),
      });
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);

    return () => clearInterval(interval);
  }, [targetDate]);

  return (
    <div className={className}>
      <h1 className="text-center text-headingl font-title">{title}</h1>
      <h1 className="text-center text-headingl font-title">{text}</h1>
      <div className="flex gap-x-4 justify-center text-center mt-6">
        <div className="flex flex-col items-center w-16">
          <p className="text-3xl font-title text-headingxxl text-neutral-grey-700 md:text-4xl">
            {timeLeft.days}
          </p>
          <p className="text-bodyl text-neutral-grey-700 tracking-wider">
            {daysLabel}
          </p>
        </div>
        <div className="flex flex-col items-center w-16">
          <p className="text-3xl font-title text-headingxxl text-neutral-grey-700 md:text-4xl">
            {timeLeft.hours}
          </p>
          <p className="text-bodyl  text-neutral-grey-700 tracking-wider">
            {hoursLabel}
          </p>
        </div>
        <div className="flex flex-col items-center w-16">
          <p className="text-3xl font-title text-headingxxl text-neutral-grey-700 md:text-4xl">
            {timeLeft.minutes}
          </p>
          <p className="text-bodyl text-neutral-grey-700 tracking-wider">
            {minutesLabel}
          </p>
        </div>
        <div className="flex flex-col items-center w-16">
          <p className="text-3xl font-title text-headingxxl text-neutral-grey-700  md:text-4xl">
            {timeLeft.seconds}
          </p>
          <p className="text-bodyl text-neutral-grey-700 tracking-wider">
            {secondsLabel}
          </p>
        </div>
      </div>
    </div>
  );
};

